import { useState } from 'react';

export default function Portfolio() {
  const [activeTab, setActiveTab] = useState('Todos');

  const tabs = ['Todos', 'Logotipos', 'Banners', 'Flyers', 'Redes Sociales'];

  const projects = [
    { 
      title: 'Logotipo Restaurante Gourmet', 
      category: 'Logotipos', 
      image: 'https://public.readdy.ai/ai/img_res/efd22ed46055c59bd4067985a58352fa.jpg' 
    },
    { 
      title: 'Banner Campaña Digital', 
      category: 'Banners', 
      image: 'https://readdy.ai/api/search-image?query=digital%20advertising%20banner%20mockup%20on%20laptop%20screen%20and%20mobile%20device%2C%20modern%20e-commerce%20campaign%20design%2C%20vibrant%20colors%20with%20call-to-action%20button%2C%20professional%20web%20banner%20layout%2C%20clean%20desk%20setup%20with%20simple%20background%2C%20realistic%20device%20mockup&width=600&height=400&seq=portfolio-banner-digital-002&orientation=landscape' 
    },
    { 
      title: 'Flyer Evento Corporativo', 
      category: 'Flyers', 
      image: 'https://readdy.ai/api/search-image?query=corporate%20event%20flyer%20design%20mockup%20held%20in%20hands%2C%20professional%20business%20conference%20promotional%20material%2C%20clean%20modern%20layout%20with%20event%20details%2C%20navy%20blue%20and%20white%20color%20scheme%2C%20realistic%20presentation%20on%20simple%20background%2C%20high%20quality%20print%20design&width=500&height=650&seq=portfolio-flyer-corporate-003&orientation=portrait' 
    },
    { 
      title: 'Posts Instagram Café', 
      category: 'Redes Sociales', 
      image: 'https://readdy.ai/api/search-image?query=instagram%20social%20media%20post%20design%20mockup%20on%20smartphone%20screen%2C%20coffee%20shop%20branding%20content%2C%20warm%20brown%20tones%20with%20coffee%20imagery%2C%20engaging%20visual%20layout%20for%20stories%20and%20feed%2C%20phone%20held%20in%20hand%20with%20simple%20background%2C%20modern%20social%20media%20design&width=500&height=600&seq=portfolio-social-cafe-004&orientation=portrait' 
    },
    { 
      title: 'Logotipo Tech Startup', 
      category: 'Logotipos', 
      image: 'https://readdy.ai/api/search-image?query=technology%20startup%20logo%20design%20mockup%20on%20laptop%20and%20business%20stationery%2C%20modern%20minimalist%20tech%20branding%2C%20geometric%20shapes%20with%20gradient%20colors%2C%20innovative%20digital%20company%20identity%2C%20professional%20presentation%20on%20white%20desk%2C%20clean%20contemporary%20style&width=600&height=450&seq=portfolio-logo-tech-005&orientation=landscape' 
    },
    { 
      title: 'Banner Venta Especial', 
      category: 'Banners', 
      image: 'https://readdy.ai/api/search-image?query=promotional%20sale%20banner%20mockup%20on%20billboard%20and%20digital%20screen%2C%20retail%20special%20offer%20advertising%20design%2C%20bold%20red%20and%20yellow%20colors%20with%20discount%20text%2C%20eye-catching%20commercial%20banner%2C%20realistic%20outdoor%20and%20indoor%20display%2C%20high%20impact%20marketing%20material&width=600&height=400&seq=portfolio-banner-sale-006&orientation=landscape' 
    },
    { 
      title: 'Flyer Fitness Center', 
      category: 'Flyers', 
      image: 'https://readdy.ai/api/search-image?query=fitness%20gym%20flyer%20design%20mockup%20on%20table%20with%20dumbbells%2C%20energetic%20sports%20promotional%20material%2C%20dynamic%20layout%20with%20athlete%20imagery%2C%20vibrant%20orange%20and%20black%20colors%2C%20motivational%20fitness%20marketing%2C%20realistic%20gym%20environment%20background&width=500&height=650&seq=portfolio-flyer-fitness-007&orientation=portrait' 
    },
    { 
      title: 'Contenido Facebook Boutique', 
      category: 'Redes Sociales', 
      image: 'https://readdy.ai/api/search-image?query=facebook%20social%20media%20content%20mockup%20on%20tablet%20device%2C%20fashion%20boutique%20promotional%20posts%2C%20elegant%20pink%20and%20gold%20aesthetic%2C%20stylish%20product%20showcase%20layout%2C%20engaging%20visual%20content%20for%20fashion%20brand%2C%20modern%20tablet%20display%20with%20simple%20background&width=550&height=550&seq=portfolio-social-boutique-008&orientation=squarish' 
    }
  ];

  const filteredProjects = activeTab === 'Todos' 
    ? projects 
    : projects.filter(project => project.category === activeTab);

  return (
    <section id="portafolio" className="py-24 bg-gradient-to-b from-[#0f0520] via-[#1a0b2e] to-[#2d1b4e] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#ff00ff] rounded-full mix-blend-screen filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-[#00ffff] rounded-full mix-blend-screen filter blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-block bg-gradient-to-r from-[#ff00ff]/20 to-[#00ffff]/20 backdrop-blur-sm border border-[#00ffff]/30 px-5 py-2 rounded-full mb-6">
            <span className="text-xs font-bold text-[#00ffff] uppercase tracking-wide">
              Nuestro Trabajo
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Proyectos que hablan por sí mismos
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-8 mb-16 border-b border-[#00ffff]/20">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-4 font-semibold transition-all cursor-pointer whitespace-nowrap relative ${
                activeTab === tab
                  ? 'text-[#00ffff]'
                  : 'text-[#c0c0ff] hover:text-white'
              }`}
            >
              {tab}
              {activeTab === tab && (
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#ff00ff] via-[#00ffff] to-[#ff00aa] shadow-lg shadow-[#00ffff]/50"></div>
              )}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {filteredProjects.map((project, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#1a0b2e]/80 to-[#2d1b4e]/80 backdrop-blur-sm border border-[#00ffff]/20 rounded-2xl p-6 hover:border-[#ff00ff]/50 transition-all duration-300 group cursor-pointer hover:shadow-2xl hover:shadow-[#ff00ff]/30"
            >
              <div className="relative overflow-hidden rounded-xl mb-4 h-64">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#ff00ff]/90 via-[#00ffff]/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <button className="bg-white text-[#1a0b2e] px-6 py-3 rounded-full font-semibold hover:bg-[#00ffff] hover:text-white transition-colors whitespace-nowrap shadow-lg">
                    Ver proyecto
                  </button>
                </div>
              </div>
              <h3 className="font-bold text-lg text-white">{project.title}</h3>
              <p className="text-sm text-[#c0c0ff] mt-1">{project.category}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
